<script setup lang="ts">
import { NxtSection, NxtSkeleton } from '@nxtpeople/nxt-styles';

defineProps({
   withTable: { type: Boolean, default: false },
   loadingRowCount: { type: Number, default: 5 },
   loadingColCount: { type: Number, default: 5 },
});
</script>

<template>
   <Suspense>
      <slot></slot>

      <template #fallback>
         <div class="loading-section">
            <NxtSection :loading="true">
               <template #title>
                  <NxtSkeleton />
               </template>

               <div v-if="withTable" class="d-flex flex-column align-items-center">
                  <NxtTable :count="0" :loading="true" :loading-row-count="loadingRowCount" :loading-col-count="loadingColCount" />
               </div>
            </NxtSection>
         </div>
      </template>
   </Suspense>
</template>

<style lang="ts" scoped></style>
